import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

import pxToRem from "assets/theme/functions/pxToRem";

const { grey } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      display: "grid !important",
      placeItems: "center !important",
      width: "100% !important",
      height: "auto !important",
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      fontSize: `${size.sm} !important`,
      fontWeight: `${fontWeightRegular} !important`,
      lineHeight: "1.4 !important",
      color: `${grey[600]} !important`,
      backgroundColor: "rgba(255, 255, 255, 0.1) !important",
      backgroundClip: "padding-box !important",
      border: "1px solid rgba(255, 255, 255, 0.15) !important",
      appearance: "none !important",
      borderRadius: borderRadius.md,
      transition: "box-shadow 150ms ease, border-color 150ms ease, padding 150ms ease !important",
    },

    input: {
      width: "100% !important",
      height: `${pxToRem(22)}`,
      padding: "0 !important",
      color: "#fff !important",

      "&::-webkit-input-placeholder": {
        color: "rgba(255, 255, 255, 0.6) !important",
      },
    },
  },
};
